import { storyblokEditable } from "gatsby-source-storyblok"
import React from "react"

import CentreCTA from "../../../V2/Banners/CentreCTA"

import { storyblokLinkToYocoLink } from "@utils/storyblok"

const StoryblokCentreCTABanner = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.CentreCTABanner>) => {
  return (
    <CentreCTA
      backgroundColor={blok.backgroundColor}
      imageUrl={blok.image.filename}
      imageAlt={blok.image.alt}
      buttonColor={blok.ctaColor}
      buttonLink={storyblokLinkToYocoLink(blok.ctaLink) ?? ""}
      rounded={blok.rounded}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokCentreCTABanner
